import React from "react";
import api from "../lib/api";
import { toast } from "sonner";

// Drop-in replacement for <a href={fileUrl(path)}>. Fetches the file through
// an authenticated request (Authorization header, not a JWT in the URL) and
// opens it (new tab) or downloads it via a local blob URL.
export default function AuthFileLink({ path, children, className, download, ...rest }) {
  const open = async (e) => {
    e.preventDefault();
    if (!path) return;
    try {
      const r = await api.get(`/files/${path}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      if (download) {
        const a = document.createElement("a");
        a.href = url; a.download = typeof download === "string" ? download : "";
        document.body.appendChild(a); a.click(); a.remove();
      } else {
        window.open(url, "_blank", "noopener,noreferrer");
      }
      setTimeout(() => URL.revokeObjectURL(url), 30000);
    } catch { toast.error("Échec du téléchargement"); }
  };
  return (
    <a href="#" onClick={open} className={className} {...rest}>
      {children}
    </a>
  );
}
